import { FormattedMessage } from 'react-intl'

import noChart from '@static/images/dashboards/no-data_chart.png'
import './ErrorChart.css'

export default function ErrorChart() {
  return (
    <div className="widget-view widget-view-error">
      <div className="wrapper">
        <img src={noChart} alt="" />
        <h4>
          <FormattedMessage id="widget-view.error.title" />
        </h4>
      </div>
    </div>
  )
}
